import { ChatChannelElementProps } from 'interfaces/ChatChannelElementProps';

export const enum ChannelActionType {
    SetAllChannels = 'CHANNELS/SET_ALL_CHANNELS',
}

export type SetAllChannelsAction = ReturnType<typeof setAllChannels>;
export const setAllChannels = (channels: ChatChannelElementProps[]) => ({
    type: ChannelActionType.SetAllChannels,
    payload: channels,
});
